import { Button } from "@mui/material";
import React, { useState } from "react";
import DivisionCmp from "../../components/cards/DivisionCmp";
import DividerDesignCmp from "../../components/divider/dividerDesignCmp";
import Grid from "@mui/material/Grid";
import { HandleNext } from "../../models/sharedFunctions";
import { useQueryClient } from "react-query";
import {
  NATIONAL_CODE,
  LOAN_TEMPLATE_INFOS,
  LOAN_ID,
  HAS_REGISTER_REQUEST,
  TEXT_DROPDOWN,
} from "../../config/cacheKey";
import { LoanTemplateInfo } from "../../models/loan.model";
import { Card, CardContent, Typography } from "@mui/material";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import CardHintCmp from "../../components/cardHint/cardHintCmp";

function _DesignSpecifications({ handleNext }: HandleNext) {
  const queryClient = useQueryClient();

  const LoanTemplateInfo = queryClient.getQueryData<LoanTemplateInfo>(
    LOAN_TEMPLATE_INFOS
  );
  const hasRegisterRequest = queryClient.getQueryData<boolean>(
    HAS_REGISTER_REQUEST
  );
  const loan_id1 = queryClient.getQueryData(LOAN_ID);
  const [loan_id, setLoan_id] = useState();
  const setLoanId = (id: any) => {
    setLoan_id(id);
  };
  const handleNextStep=()=>{
    queryClient.setQueryData(TEXT_DROPDOWN,'' );
    handleNext()
  }
  return (
    <div style={{ margin: "20px 20px 0px 20px"}}  >
      <CardHintCmp icon={<ReportProblemOutlinedIcon />} width='100%' title='با در نظر گرفتن جزییات طرح ها، طرح مورد نظر خود را انتخاب نمایید:'/>
      {/* <CardContent
        sx={{
          background: `#F1F4FF`,
          textAlign: "justify",
          borderRadius: "10px",s
          marginBottom: "15px",
          marginTop: "-10px",
          border: "1px solid #DAE0E4",
          boxShadow: "1px 2px #dae0e4",
        }}
      >
        <Typography color="text.secondary" gutterBottom>
          <div style={{fontFamily:"iranSans",color: "#1D4A87",fontSize: "16px"}}>
            {<ReportProblemOutlinedIcon />} با در نظر گرفتن جزییات طرح ها، طرح
            مورد نظر خود را انتخاب نمایید:{" "}
          </div>
        </Typography>
      </CardContent> */}
      <DividerDesignCmp hasRegisterRequest={hasRegisterRequest} value={LoanTemplateInfo} setLoanId={setLoanId} handleNext={handleNext} />
      <Grid container spacing={1} justifyContent="flex-end" >
        <Button
          type="submit"
          disabled={!loan_id}
          className={`${
            !loan_id
              ? "btnForm disabledBtn  marginLeft-10 alignLeft"
              : "btnForm SuccessDefault  marginLeft-10 alignLeft"
          }`}
          style={{ width: "120px" }}
          onClick={handleNextStep}
          
        >
          تایید و ادامه
        </Button>
      </Grid>
    </div>
  );
}
export default function DesignSpecifications({ handleNext }: HandleNext) {
  const child = <_DesignSpecifications handleNext={handleNext} />;
  return <DivisionCmp child={child} title="  انتخاب طرح  " />;
}

